export function shouldSlideShowNavigation(questionType: string) {
  return ['slide', 'qfa', 'quiz_leaderboard'].includes(questionType);
}
